<div class="w-100 landing">
  <div class="container-landing">
    <img
      style="width: 100%"
      [src]="
        isMobile
          ? 'assets/images/landing/background_mobile.png'
          : 'assets/images/landing/background.png'
      "
    />
  </div>
  <div>
    <div class="meetings-section">
      <div id="events" class="section-title">
        {{ "Current Events" | translate }}
      </div>
      <div class="row">
        <div
          *ngFor="let card of cards"
          class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12"
        >
          <app-meeting-card
            [isMobile]="isMobile"
            [card]="card"
          ></app-meeting-card>
        </div>
      </div>
    </div>
    <div id="contact-us" class="contact-us-section">
      <app-contact-us></app-contact-us>
    </div>
  </div>
  <app-footer></app-footer>
</div>
